var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';
import MenuItem from '@material-ui/core/MenuItem';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import React from 'react';
import classNames from 'classnames';
import { divider, iconLight } from '../Styles/Colours';
import { SearchIcon } from './Icons';
import styles from './SearchInput.module.css';
var popperModifiers = {
    flip: {
        enabled: false
    },
    offset: {
        offset: '6px, 0'
    },
    preventOverflow: {
        enabled: true,
        boundariesElement: 'window'
    },
    hide: {
        enabled: false
    },
    arrow: {
        enabled: false
    }
};
var popperStyles = { zIndex: 9999, minWidth: 375 };
function renderSuggestion(_a) {
    var suggestion = _a.suggestion, itemToString = _a.itemToString, index = _a.index, itemToMenuKey = _a.itemToMenuKey, customItemRender = _a.customItemRender, onClick = _a.onClick;
    var handleClick = function () {
        return onClick(suggestion);
    };
    return (React.createElement(MenuItem, { onMouseDown: handleClick, key: itemToMenuKey ? itemToMenuKey(suggestion) : itemToString(suggestion), component: 'div', style: {
            borderBottom: "1px solid " + divider,
            paddingTop: 8,
            paddingBottom: 7,
            maxWidth: '100%',
            textOverflow: 'ellipsis',
            display: 'block'
        }, "data-test-id": "singleSelect_menuItem_" + index }, customItemRender ? customItemRender(suggestion) : itemToString(suggestion)));
}
function dropDownMessage(message, testId) {
    if (message === void 0) { message = 'No results found'; }
    return (React.createElement("div", { key: testId, className: styles.dropDownMessage, "data-test-id": testId }, message));
}
var defaultResultToString = function () {
    throw new Error('Item to string handler missing');
};
var defaultResultClick = function () {
    throw new Error('Result clicked with no handler');
};
export var InputModes;
(function (InputModes) {
    InputModes["Standard"] = "standard";
    InputModes["Collapsible"] = "collapsible";
})(InputModes || (InputModes = {}));
var SearchInput = /** @class */ (function (_super) {
    __extends(SearchInput, _super);
    function SearchInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            focused: false,
            collapsed: false
        };
        _this.input = React.createRef();
        _this.searchButton = React.createRef();
        _this.container = React.createRef();
        _this.userFocused = function (e) {
            _this.setState({
                focused: true,
                collapsed: false
            }, function () {
                if (_this.props.onFocus)
                    _this.props.onFocus(e);
            });
        };
        _this.userBlur = function (e) {
            if (_this.props.onBlur)
                _this.props.onBlur(e);
            // if blur event on the text input is triggered because the user clicked on the search icon,
            // ignore the blur event and let the search icon handle the click event to prevent
            // doubling up on handling of a single event from the user's perspective
            var target = e.relatedTarget || document.activeElement;
            if (target === _this.searchButton) {
                return;
            }
            _this.setState({
                focused: false
            });
            if (!_this.props.value) {
                _this.setState({
                    collapsed: true
                });
            }
        };
        _this.searchIconClick = function (e) {
            _this.setState(function (state) { return ({
                focused: !state.focused,
                collapsed: !state.collapsed
            }); }, function () {
                if (!_this.state.focused || _this.state.collapsed) {
                    _this.setState({
                        focused: false,
                        collapsed: true
                    });
                    return;
                }
                if (_this.input.current)
                    _this.input.current.focus();
                _this.userFocused(e);
            });
        };
        _this.userClickedClear = function () {
            _this.setState({
                collapsed: false
            }, function () {
                if (_this.props.onClear)
                    _this.props.onClear();
                if (_this.input && _this.input.current)
                    _this.input.current.focus();
            });
        };
        return _this;
    }
    SearchInput.getDerivedStateFromProps = function (props, state) {
        if (!props.value && !state.focused) {
            return {
                collapsed: true
            };
        }
        return null;
    };
    SearchInput.prototype.render = function () {
        var _a, _b;
        var _this = this;
        var mode = this.props.mode || InputModes.Standard;
        var className = classNames(styles.container, (_a = {},
            _a[styles.dirty] = !!this.props.value,
            _a[styles.focused] = this.state.focused,
            _a[styles.fullWidth] = this.props.fullWidth,
            _a[styles.collapsed] = this.state.collapsed,
            _a[styles.standard] = mode === InputModes.Standard,
            _a[styles.collapsible] = mode === InputModes.Collapsible,
            _a));
        var clearButtonClasses = {
            root: classNames(styles.clearButton, (_b = {},
                _b[styles.hidden] = !this.props.value,
                _b))
        };
        var width = this.container.current ? this.container.current.clientWidth : 0;
        var isOpen = this.state.focused && ((!!this.props.results && this.props.results.length > 0) || !!this.props.noResults);
        var menuStyles = { width: width, minWidth: 375, maxHeight: 400, overflow: 'auto' };
        var maxResults = this.props.maxResults || 10;
        var disablePortal = this.props.disablePortal !== undefined ? this.props.disablePortal : true;
        var NOOP = function () {
            return;
        };
        var changeMethod = this.props.onChange || NOOP;
        return (React.createElement("div", { className: className, ref: this.container },
            React.createElement("div", { ref: this.searchButton, onClick: this.searchIconClick, className: styles.searchIcon },
                React.createElement(SearchIcon, { size: '32', color: iconLight })),
            React.createElement("div", { className: styles.searchComponents },
                React.createElement("input", { id: this.props.inputId, autoFocus: this.props.autoFocus, type: 'text', ref: this.input, "data-lpignore": 'true', value: this.props.value || '', placeholder: this.props.placeholder, className: styles.inputField, onChange: changeMethod, onFocus: this.userFocused, onBlur: this.userBlur, onKeyDown: this.props.onKeyDown, "data-test-id": this.props.testId + "-input-field" }),
                React.createElement(Button, { onClick: this.userClickedClear, size: 'small', disabled: !this.props.value, "data-test-id": this.props.testId + "-input-button", classes: clearButtonClasses },
                    React.createElement(Icon, { classes: { root: styles.iconRoot } }, "cancel"))),
            React.createElement(Popper, { open: isOpen, anchorEl: this.container.current, modifiers: popperModifiers, style: popperStyles, disablePortal: disablePortal, "data-test-id": this.props.testId + "-input-results" },
                React.createElement(Paper, { style: menuStyles, square: true },
                    this.props.results &&
                        this.props.results
                            .filter(function (result, index) { return index < maxResults; })
                            .map(function (result, index) {
                            return renderSuggestion({
                                suggestion: result,
                                itemToString: _this.props.resultToString || defaultResultToString,
                                index: index,
                                itemToMenuKey: _this.props.getResultKey || defaultResultToString,
                                customItemRender: _this.props.renderResult,
                                onClick: _this.props.onResultClick || defaultResultClick
                            });
                        }),
                    this.props.noResults &&
                        dropDownMessage(this.props.noResultsMessage, "singleSelect_menuItem_no_results"),
                    this.props.results &&
                        this.props.results.length > maxResults &&
                        dropDownMessage('More results found - type to refine', "singleSelect_menuItem_too_many_results")))));
    };
    return SearchInput;
}(React.Component));
export { SearchInput };
